import { render, staticRenderFns } from "./mobileAndShoppingIndex.vue?vue&type=template&id=6573057a&scoped=true"
import script from "./mobileAndShoppingIndex.vue?vue&type=script&lang=js"
export * from "./mobileAndShoppingIndex.vue?vue&type=script&lang=js"
import style0 from "./mobileAndShoppingIndex.vue?vue&type=style&index=0&id=6573057a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6573057a",
  null
  
)

export default component.exports